<template>
  <div
    id="mini-map"
    ref="miniMapRef"
  />
</template>

<script setup>
import {ref, inject, onMounted, watch} from 'vue';
import {View} from 'ol';
import {OverviewMap} from 'ol/control';
// #region Props, Emits
// #endregion

// #region Params, Ref, Reactives, Computed
let miniMapControl = null;
const MIN_ZOOM_MINIMAP = 4;
const MAX_ZOOM_MINIMAP = 5;
const miniMapRef = ref(null);
const mapRef = inject('instanceMapRef');
const GROUP_MINIMAP_MAPS = inject('GROUP_MINIMAP_MAPS');
// #endregion

// #region Functions
// Pre: miniMapRef?.value && !!layers?.length
function createMiniMap(map, layers) {
  const origView = map.getView();

  const miniMapView = new View({
    projection: origView.getProjection(),
    center: origView.getCenter(),
    zoom: origView.getZoom(),
    minZoom: MIN_ZOOM_MINIMAP,
    maxZoom: MAX_ZOOM_MINIMAP,
    // maxZoom: origView.getMaxZoom(),
  });
  const options = {
    layers,
    collapseLabel: '\u00BB',
    label: '\u00AB',
    collapsed: false,
    view: miniMapView,
    target: miniMapRef.value,
  };
  miniMapControl = new OverviewMap(options);
}
// Pre: miniMapRef?.value && !!layers?.length
function addMiniMap(map, layers) {
  if (!miniMapControl) {
    createMiniMap(map, layers);
  }
  // createMiniMap(map, layers);
  map.removeControl(miniMapControl);
  map.addControl(miniMapControl);
}
// #endregion

// #region Effects, Hooks
watch([mapRef, () => GROUP_MINIMAP_MAPS?.getLayers().getArray() ?? []],
  ([newMapRef, newLayers]) => {
    if (!!newMapRef && !!miniMapRef?.value && !!newLayers?.length) {
      addMiniMap(newMapRef, newLayers);
    }
  });
onMounted(async () => {
  const layers = GROUP_MINIMAP_MAPS?.getLayers().getArray() ?? [];
  if (!!mapRef?.value && !!miniMapRef?.value && !!layers?.length) {
    addMiniMap(mapRef.value, layers);
  }
});
// #endregion

// #region Provide, Expose

// #endregion
</script>

<style lang="scss" scoped>
</style>
